<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("add") }} {{ $tc("myFestivalMovies", 1) }}
      </div>
      <router-link class="btn-blue" to="/mycinemas/myfestival-movies"
        >{{ $tc("categorylinkmovies", 1) }} {{ $tc("list", 1) }}</router-link
      >
    </div>

    <div class="white-wrapper my-3">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <multiselect
              :options="Categories"
              v-model="selectedCategory"
              :searchable="true"
              label="category_name"
              track-by="category_id"
              :placeholder="$tc('selectCategory')"
              @input="onSelectCategory($event)"
              :allowEmpty="false"
              v-validate="'required'"
            ></multiselect>
            <Tooltip :title="$t('pleaseSelectCategory')" />
          </div>
          <p
            v-if="
              submitted &&
                (selectedCategory == undefined || selectedCategory == '')
            "
            class="error_message"
          >
            {{ msgCategory }}
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <multiselect
              :options="Movies"
              v-model="movies"
              :searchable="true"
              label="movie_title"
              track-by="movie_id"
              :placeholder="$tc('selectMovies')"
              :allowEmpty="false"
              :showLabels="false"
              :multiple="true"
            ></multiselect>
            <Tooltip :title="$t('pleaseSelectMovie')" />
          </div>
          <p v-if="submitted && movies.length == 0" class="error_message">
            {{ msgMovie }}
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="category_link_name"
                name="category_link_name"
                v-validate="'required'"
                v-model="category_link_name"
                @input="onChangeItemName($event, 'name')"
                placeholder="."
              />
              <label>{{ $t("event") }} {{ $t("name") }}</label>
            </div>
            <Tooltip :title="$t('category_link_name')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('category_link_name')">{{
              errors.first("category_link_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="row">
            <div class="col-10">
              <div class="d-flex align-items-center">
                <label
                  class="material-file-upload"
                  @click.prevent.stop="setModalData(2160, 2160, 1)"
                >
                  <div class="text-truncate p-2">
                    {{
                      category_link_image.length > 0
                        ? category_link_image
                        : "Please Select Image"
                    }}
                  </div>
                </label>
              </div>
            </div>
            <div class="col-2 align-self-center pl-3">
              <ImagePreviewer
                    :clickFunc="
                      () => {
                        openImageModal(1)
                      }
                    "
                    :img="
                      _GetImagePath(category_link_image)
                    "
                  />
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && !category_link_image && category_id == 3">
              {{ 'Please Select Image' }}
            </span>
          </p>
        </div>

        <div v-if="category_id == 3" class="col-lg-6 col-xl-4 mb-4">
          <div class="row">
            <div class="col-10">
              <div class="d-flex align-items-center">
                <label
                  class="material-file-upload"
                  @click.prevent.stop="setModalData(900, 2400, 2)"
                >
                  <div class="text-truncate p-2">
                    {{
                      category_banner_image
                        ? category_banner_image
                        : "Banner Image 2400 * 900"
                    }}
                  </div>
                  
                </label>
              </div>
            </div>
            <div class="col-2 align-self-center pl-3">
              <ImagePreviewer
                    :clickFunc="
                      () => {
                        openImageModal(2)
                      }
                    "
                    :img="
                      _GetImagePath(category_banner_image)
                    "
                  />
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && !category_banner_image && category_id == 3">
              {{ 'Please Select Banner Image' }}
            </span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material-textarea">
              <textarea
                v-model="category_link_description"
                rows="1"
                @input="onChangeItemName($event, 'desc')"
              ></textarea>
              <label>{{ $tc("category", 1) }} {{ $t("description") }}</label>
            </div>
            <Tooltip :title="$t('category_link_description')" />
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="link_url"
                name="link_url"
                v-model="link_url"
                placeholder="."
              />
              <label
                >{{ $tc("category", 1) }} {{ $t("link") }}
                {{ $t("url") }}</label
              >
            </div>
            <Tooltip :title="$t('link_url')" />
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="from_date"
                  v-on:click="from_date = null"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="from_date"
                  name="fromdate"
                  id="fromdate"
                  typeable
                ></Datepicker>
                <label :class="from_date ? 'active' : ''"
                  >{{ $t("select") }} {{ $t("fromdate") }}</label
                >
              </div>
            </div>
            <Tooltip :title="$t('selectFromDate')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && !from_date">
              {{ $t("selectFromDate") }}
            </span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="to_date"
                  v-on:click="to_date = null"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="to_date"
                  name="todate"
                  id="todate"
                  typeable
                ></Datepicker>
                <label :class="to_date ? 'active' : ''"
                  >{{ $t("select") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
            <Tooltip :title="$t('selectToDate')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && !to_date">
              {{ $t("selectToDate") }}
            </span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <label class="ios-switch">
              <input
                type="checkbox"
                class="ios-checkbox"
                v-model="cat_link_is_active"
              />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="Language-section px-4">
        <div
          v-for="(Lang, LangIndex) in LangContent"
          :key="LangIndex"
          class="row"
        >
          <h5 class="col-md-12 mt-3 mb-3 d-flex">
            <span>{{ Lang.langauge }}</span>
            <button
              @click.prevent.stop="translateToOtherLangs(Lang, LangIndex)"
              class="btn-blue btn-blue-sm ml-2"
            >
              {{ $t("translate") }}&nbsp;
              <b-spinner
                v-if="translationLoading[LangIndex] == true"
                small
                variant="light"
                label="Spinning"
                class="translate-spinner"
              ></b-spinner>
            </button>
          </h5>

          <div class="col-md-3">{{ $t("event") }} {{ $t("name") }}:</div>
          <div class="col-md-9">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="Lang.category_link_name"
                  placeholder="."
                  name="category_link_name_lang"
                  id="category_link_name_lang"
                  v-validate="
                    Lang.langauge.toLowerCase() === 'english' ? 'required' : ''
                  "
                />
              </div>
              <Tooltip :title="$t('category_link_name')" />
            </div>
            <p class="error_message">
              <span
                v-if="
                  submitted &&
                    Lang.langauge.toLowerCase() === 'english' && !Lang.category_link_name
                "
                >{{ 'Category link name required.' }}</span
              >
            </p>
          </div>

          <div class="col-md-3 mt-2">
            {{ $tc("category", 1) }} {{ $t("description") }}
          </div>
          <div class="col-md-9 mt-2">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="Lang.category_link_description"
                  placeholder="."
                  name="category_link_description_lang"
                  id="category_link_description_lang"
                  v-validate="
                    Lang.langauge.toLowerCase() == 'english' && category_id !== 4 ? 'required' : ''
                  "
                />
              </div>
              <Tooltip :title="$t('category_link_description')" />
            </div>
            <p class="error_message">
              <span
                v-if="
                  submitted &&
                    Lang.langauge.toLowerCase() === 'english' &&
                    !Lang.category_link_description
                "
                >{{ "Category Link Description Required." }}</span
              >
            </p>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button @click.prevent.stop="addCategoryLink()" class="btn-blue mt-5">
          {{ $t("save") }}
        </button>
      </div>
    </div>
    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">Preview</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <br />
      <img v-if="previewType == 1" :src="_GetImagePath(category_link_image)" class="img-fluid" />
      <img v-if="previewType == 2" :src="_GetImagePath(category_banner_image)" class="img-fluid" />
    </b-modal>
    <ImageGallery
      v-bind:propImageName="category_link_image || 'Movie Festival'"
      :img_desc="category_link_image || 'Movie Festival'"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
        :showPercentageLoader="true"
        menu="B"
      :category="'Movie Banner'"
      :resetImgData="false"
    ></ImageGallery>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MyCinemaService from "@/services/MyCinemaService";
import { mapGetters } from "vuex";
import scheduleService from "@/services/scheduleService";
import MovieService from "@/services/MovieService";
import ImageGallery from "../../Pages/ImageGallery/imageGalleryModal.vue";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import ImagePreviewer from "@/components/Partials/ImagePreviewer.vue";

export default {
  components: { VueCropper, ImageGallery, ImagePreviewer },
  data() {
    return {
      submitted: false,
      Cinemas: [],
      Categories: [],
      Movies: [],
      selectedCinema: undefined,
      selectedCategory: undefined,
      cat_link_is_active: true,
      movies: [],
      category_id: null,
      category_link_image: "",
      category_banner_image: "",
      category_link_name: undefined,
      category_link_description: "",
      from_date: "",
      to_date: "",
      link_url: "",
      cinema_id: null,
      msgMovie: "Please Select the Movie",
      msgCategory: "Please Select Category",
      msgCinema: "Please Select Cinema",

      set_width: null,
      set_height: null,
      showModal: false,
      imgSrc: "",
      cropImg: "",
      filename: "",
      ContentLanguages: [],
      LangContent: [],
      translationLoading: [false, false, false, false, false, false],
      translated: [false, false, false, false, false, false],
      tempModalImagePath: null,
      tempModalImageName: "",
      x_dimension: 2160,
      y_dimension: 2160,
      calledBy: null,
      previewType: null
    };
  },
  computed: {
    ...mapGetters(["finalImagePath"])
  },
  watch: {
    finalImagePath(newval) {
      if(this.calledBy == 1) {
        this.category_link_image = newval;
      } else if(this.calledBy == 2) {
        this.category_banner_image = newval;
      }
    }
  },
  beforeMount() {
    this.getCategoryList();
    this.getAllActiveMovies();
    this.getContentLangauge();
  },
  methods: {
    openImageModal: function(type) {
      this.previewType = type;
      this.$refs["preview-modal"].show();
    },
    setModalData(height, width, calledBy) {
      this.calledBy = calledBy;
      this.set_height = height;
      this.set_width = width;
      this.showModal = !this.showModal;
    },
    getCinemaList: function(cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    getCategoryList: function() {
      MyCinemaService.GetSuperCategory()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Categories = data.Records;
            console.log("SuperCategories", this.Categories);
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    getContentLangauge: function() {
      MovieService.GetMovieContentLanguages()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
              //   "langauge"
              // ]);
              this.ContentLanguages = data.ContentLanguages;
            }
            console.log("this.ContentLanguages", this.ContentLanguages);
          } else {
            // Show Error:
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers();
        })
        .catch(error => {
          // Catch Error:
        });
    },
    makeLangContainers: function() {
      this.ContentLanguages.map(x => {
        let Obj = {
          ...x,
          category_link_name: "",
          category_link_description: ""
        };
        this.LangContent.push(Obj);
        console.log("this.LangContent", this.LangContent);
      });
    },
    getAllActiveMovies: function() {
      // let payload = {
      //   limit: null,
      //   currentPage: null,
      //   searchValue: null
      // };
      let payload = {
        movie_is_active: "Y"
      };
      MovieService.GetActiveMasterMovies(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.Movies = data.Records;
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch Error on getAllActiveMovies :", error);
        });
    },
    translateToOtherLangs: function(Content, index) {
      let englishContent = this.LangContent.find(x => {
        if (
          (x.category_link_name && x.category_link_name.length > 0) ||
          (x.category_link_description &&
            x.category_link_description.length > 0)
        ) {
          return true;
        }
      });

      if (
        !englishContent ||
        !englishContent.category_link_name ||
        !englishContent.category_link_description
      ) {
        this.$toasted.show("Please enter all details for any language");
        return;
      }

      let targetLang = Content.iso_2;

      if (!targetLang) {
        this.$toasted.show(
          "No ISO code found for " + Content.langauge + "language"
        );
        return;
      }
      this.translationLoading[index] = true;

      this.$forceUpdate();

      MovieService.GetDeeplTranslations({
        target_langs: [targetLang],
        text: [
          englishContent.category_link_name,
          englishContent.category_link_description
        ]
      })
        .then(resp => {
          const { data } = resp;
          console.log("data", data);

          if (data.status) {
            let translations = data.data[targetLang].translations;

            Content.category_link_name = translations[0].text;
            Content.category_link_description = translations[1].text;
            this.translated[index] = true;
          }
        })
        .catch(err => {
          this.$toasted.show("Error when fetching translations");
          console.log("Error while fetching translations");
          console.log(err);
        })
        .finally(() => {
          this.translationLoading[index] = false;
          this.$forceUpdate();
        });
    },
    onChangeItemName(event, type) {
      this.LangContent.map(x => {
        if (x.langauge.toLowerCase() == "english") {
          if (type == "name") {
            x.category_link_name = event.target.value;
          } else if (type == "desc") {
            x.category_link_description = event.target.value;
          }
        }
      });
    },
    onSelectCategory(category) {
      this.selectedCategory = category;
      this.category_id = category.category_id;
    },
    onSelectMovie(Movie) {
      this.movies = Movie;
      this.Movie_id = Movie.movie_id;
    },
    addCategoryLink() {
      this.submitted = true;
      if (this.movies.length == 0) {
        this.$toasted.show("Please Select the Movies");
        return;
      } else if (
        this.category_id == undefined ||
        this.category_id == null ||
        this.category_id == ""
      ) {
        this.$toasted.show("Please Select the category");
        return;
      } else if (!this.from_date) {
        return this.$toasted.show("Please Select From Date");
      } else if (!this.to_date) {
        return this.$toasted.show("Please Select To Date");
      } else if (this.from_date > this.to_date) {
        return this.$toasted.show("To Date Must be greater than From Date");
      } else if(this.category_id == 3 && !this.category_banner_image) {
        return
      } else if(this.category_id == 3 && !this.category_link_image) {
        return
      }
      this.$validator.validate().then(valid => {
        if (valid) {
          let payload = {
            category_id: this.category_id,
            movies: this.movies,
            contentArray: this.LangContent,
            category_link_image: this.category_link_image,
            category_banner_image: this.category_banner_image,
            category_link_description: this.category_link_description,
            category_link_name: this.category_link_name,
            from_date: this.from_date,
            to_date: this.to_date,
            link_url: this.link_url,
            cat_link_is_active: this.cat_link_is_active
          };
          MyCinemaService.AddCategoryLinkMovie(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  // path: "/mycinemas/list-categorylink"
                  path: "/mycinemas/myfestival-movies"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MyCinemas/CategoryLinkMovie/AddCategoryLinkMovie.vue